import { useEffect, useRef } from "react";

function getUserId() {
  let id = localStorage.getItem("zip_user_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("zip_user_id", id);
  }
  return id;
}

const EVENT_FLUSH_INTERVAL = 60000;

export function useAnalytics() {
  const userId = useRef(getUserId());
  const sessionId = useRef(crypto.randomUUID());
  const buffer = useRef([]);

  const track = (payload) => {
    buffer.current.push({
      user_id: userId.current,
      session_id: sessionId.current,
      timestamp: Date.now(),
      ...payload,
    });
  };

  const flush = () => {
    if (!buffer.current.length) return;
    navigator.sendBeacon(
      `${process.env.REACT_APP_API_BASE_URL}/events`,
      JSON.stringify(buffer.current)
    );
    buffer.current = [];
  };

  useEffect(() => {
    const interval = setInterval(flush, EVENT_FLUSH_INTERVAL);
    window.addEventListener("beforeunload", flush);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") flush();
    });

    return () => {
      flush();
      clearInterval(interval);
      window.removeEventListener("beforeunload", flush);
    };
  }, []);

  return { track };
}